import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getImageUrl } from 'ui-images';
import devLogger from 'react-utils/devLogger';
import omit from '../utils/underscore/omit';
import { isIE11 } from '../utils/BrowserTest';
import UIImage from './UIImage';
export default function UIAbstractIllustration(_ref) {
  let {
    className,
    disabled,
    name,
    _getImageUrlFromName = imageName => getImageUrl(imageName, undefined, isIE11()),
    height,
    width,
    bordered = false,
    shape = 'default',
    alt = ''
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "disabled", "name", "_getImageUrlFromName", "height", "width", "bordered", "shape", "alt"]);

  if (process.env.NODE_ENV !== 'production') {
    if (height == null && width == null) {
      devLogger.warn({
        message: 'UIAbstractIllustration: Provide either width or height prop to ensure proper scaling.',
        key: 'UIAbstractIllustration-dimensions-none'
      });
    }

    if (height != null && width != null) {
      devLogger.warn({
        message: 'UIAbstractIllustration: Setting both width and height may not behave as expected.',
        key: 'UIAbstractIllustration-dimensions-both'
      });
    }
  }

  return /*#__PURE__*/_jsx(UIImage, Object.assign({}, rest, {
    responsive: false,
    className: classNames(className, 'private-illustration', disabled && 'private-illustration--disabled'),
    objectFit: "contain",
    src: _getImageUrlFromName(name),
    bordered: bordered,
    shape: shape,
    alt: alt,
    width: width,
    height: height
  }));
}
UIAbstractIllustration.propTypes = Object.assign({}, omit(UIImage.propTypes, 'src', 'responsive', 'objectFit'), {
  /**
   * Use this prop when the illustration is inside of a disabled form element.
   */
  disabled: PropTypes.bool,

  /**
   * The height of the illustration.
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * The name of the illustration.
   */
  name: PropTypes.string.isRequired,
  // TODO: Make this type more specific (i.e. combine `name` prop-types from `UIIllustration` and `UILogo`). Issue: https://git.hubteam.com/HubSpot/UIComponents/issues/11418.

  /**
   * The width of the illustration.
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * A function that returns the URL of the image to display.
   */
  _getImageUrlFromName: PropTypes.func
});
UIAbstractIllustration.defaultProps = Object.assign({}, omit(UIImage.defaultProps, 'responsive', 'objectFit'), {
  _getImageUrlFromName: imageName => getImageUrl(imageName, undefined, isIE11())
});
UIAbstractIllustration.displayName = 'UIAbstractIllustration';